document.addEventListener('DOMContentLoaded', function () {
  try {
    var anchors = document.querySelectorAll('a[href]:not([title])');
    if (!anchors || anchors.length === 0) return;

    var isMeaningful = function (s) {
      return !!(s && typeof s === 'string' && s.trim().length > 0);
    };

    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];

      // Prefer aria-label
      var aria = a.getAttribute('aria-label');
      if (isMeaningful(aria)) {
        a.setAttribute('title', aria.trim());
        continue;
      }

      // Visible text fallback
      var text = (a.textContent || '').trim();
      if (!isMeaningful(text)) {
        // Try image alt inside link
        var img = a.querySelector('img[alt]');
        if (img && isMeaningful(img.alt)) {
          text = img.alt.trim();
        }
      }

      var href = a.getAttribute('href') || '';

      // Special schemes first
      if (href.indexOf('tel:') === 0) {
        var phone = href.replace('tel:', '');
        a.setAttribute('title', 'Call ' + phone);
        continue;
      }
      if (href.indexOf('sms:') === 0) {
        var sms = href.replace('sms:', '');
        a.setAttribute('title', 'Text ' + sms);
        continue;
      }
      if (href.indexOf('mailto:') === 0) {
        var email = href.replace('mailto:', '');
        a.setAttribute('title', 'Email ' + email);
        continue;
      }

      // Heuristic for social links if still no text
      if (!isMeaningful(text)) {
        try {
          var url = new URL(href, window.location.origin);
          var host = (url.hostname || '').replace(/^www\./, '');
          if (host.indexOf('facebook') !== -1) text = 'Facebook';
          else if (host.indexOf('instagram') !== -1) text = 'Instagram';
          else if (host.indexOf('tiktok') !== -1) text = 'TikTok';
          else if (host.indexOf('twitter') !== -1 || host.indexOf('x.com') !== -1) text = 'Twitter';
          else if (host.indexOf('youtube') !== -1) text = 'YouTube';
        } catch (e) {
          // ignore
        }
      }

      if (isMeaningful(text)) {
        a.setAttribute('title', text);
      }
    }
  } catch (e) {
    // do not break the page if anything goes wrong
  }
});
